const messagingModule = require('firebase').messaging;
export default messagingModule;
